<div class="usan-form-item continue-button-spacing">
  <button type="button" class="step-btn form-step-btn form-step-btn-style form-step-btn-text" 
    [ngClass]="isMobileDeviceSize ? 'form-step-btn__mobile' : 'form-step-btn__full'" (click)="advanceForm()">
      Continue to {{ displaySectionName }}
      <mat-icon class="form-step-btn-icon">chevron_right</mat-icon>
  </button>
</div>